import React, { FunctionComponent } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText, Size } from '../../atoms/bodyText/BodyText'
import { Avatar, avatarAltTextGeneric, AvatarDetails } from '../../atoms/icons/Avatar'
import { tID } from '../../utils'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { getEmptyMessageContent } from '../../utils/utils'

export type EmptyMessagesViewProps = {
  avatarDetails?: AvatarDetails
  displayName?: string
}

const Container = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  alignItems: 'center',
  padding: `0 ${spacing['16px']}`,
}))

const EmptyMessageContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  padding: `0 ${spacing['16px']}`,
}))

export const EmptyMessagesView: FunctionComponent<EmptyMessagesViewProps> = ({ avatarDetails, displayName }) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()
  return (
    <Container testID={tID('EmptyMessages')}>
      {avatarDetails && displayName ? (
        <>
          <Avatar
            size={80}
            details={avatarDetails}
            accessibilityLabel={formatMessage(avatarAltTextGeneric, { name: displayName })}
          />
          <EmptyMessageContainer>
            <BodyText text={getEmptyMessageContent(displayName)} size={Size.SMALL} />
          </EmptyMessageContainer>
        </>
      ) : displayName ? (
        <BodyText
          textAlign='center'
          text={
            <FormattedMessage
              defaultMessage='Your messages with {displayName} will appear here.'
              description='No previous messages'
              values={{ displayName }}
            />
          }
          size={Size.LARGE}
          color={theme.colors.textSecondary}
        />
      ) : null}
    </Container>
  )
}
